import React, {Component} from 'react';
import styled from 'styled-components';
import {Button, P2, SectionTitle} from '../Kit/Kit';
import InputField from "../InputField/InputField";
import shrimp from '../../assets/img/contactShrimp.png';

const Container = styled.div`
  padding: 32px 16px 0;
  display: grid;
  grid-row-gap: 16px;
  position: relative;
  
  @media(min-width: 768px) {
    padding: 180px 100px 0;
    grid-row-gap: 24px;
  }
  
  @media(min-width: 992px) {
    padding: 180px 200px 0;
  }
  
  @media(min-width: 1200px) {
    padding: 180px 250px 0;
  }
  
  @media(min-width: 1680px) {
    padding: 180px 400px 0;
  }
`;

const ShrimpBG = styled.img`
  display: none;
  z-index: 0;
  
  @media(min-width: 768px) {
    position: absolute;
    display: block;
    right: 0;
    height: 30%;
  }
  
  @media(min-width: 1200px) {
    height: 40%;
  }
  
  @media(min-width: 1680px) {
    height: auto;
  }
`;

const StyledTitle = SectionTitle.extend`
  //font-style: italic;
  z-index: 1;
`;

const Subtitle = P2.extend`
  z-index: 1;
`;

const Form = styled.form`
  display: grid;
  grid-row-gap: 12px;
  grid-template-columns: 1fr;
  z-index: 1;
  
  button {
    justify-self: center;
  }
`;

const encode = (data) => {
    return Object.keys(data)
      .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
      .join("&");
};

class ContactForm extends Component {
    state = {
        name: '',
        email: '',
        message: ''
    };

    handleOnChange = (event) => {
        const {name, value} = event.currentTarget;
        this.setState(() => ({[name]: value}));
    };

    handleSubmit = (event) => {
        fetch("/", {
            method: "POST",
            headers: {"Content-Type": "application/x-www-form-urlencoded"},
            body: encode({"form-name": "contact", ...this.state})
        }).then(() => alert("Message successfully sent!"))
          .catch(error => alert(error));
        event.preventDefault();
    };

    render() {
        const { name, email, message } =this.state;
        const {header, paragraph} = this.props.data;
        return (
          <Container>
              <ShrimpBG src={shrimp} alt="shrimp bg"/>
              <StyledTitle>{header}</StyledTitle>
              <Subtitle
                dangerouslySetInnerHTML={{__html: paragraph}}
              />
              <Form
                data-netlify="true"
                data-netlify-honeypot="bot-field"
                name="contact"
                method="post"
                onSubmit={this.handleSubmit}
              >
                  <InputField
                    name="name"
                    value={name}
                    type="text"
                    onChange={this.handleOnChange}
                    placeholder="Name"
                    required
                  />
                  <InputField
                    name="email"
                    value={email}
                    type="email"
                    onChange={this.handleOnChange}
                    placeholder="Name@email.com"
                    required
                  />
                  <InputField
                    name="message"
                    value={message}
                    type="textarea"
                    onChange={this.handleOnChange}
                    placeholder="Your Message"
                    required
                  />
                  <Button>Send</Button>
              </Form>
          </Container>
        );
    }
}

export default ContactForm;


// WEBPACK FOOTER //
// ./src/components/Home/ContactForm.js